const DATA_TEST_IDS = {
  permissionsEditablePermissionsPage:
    'module__permissions_editable-permissions-page',
  permissionsPermissionsPage: 'module__permissions_permissions-page',
} as const;

export default DATA_TEST_IDS;
